<!-- regular text box below -->
<div *ngIf="textBlock" [className]="textBlock.className" [ngStyle]="getStyles()">
  <div *ngIf="textBlock.text" [innerHTML]="textBlock.text | santizeValue" id="text-block"></div>
</div>
